import { Card, Divider, Button } from 'antd';
import {
	Chart as Chartjs,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import moment from 'moment';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import {
	investmentTopUpList,
	investmentTransactionStatements,
} from '../../methods/redux/reducers/investment';
import remakeQueryString from '../../methods/utils/remake-query-string';
import InvestmentTransactionStatements from './InvestmentTransactionStatement';

Chartjs.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
);

const SingleInvestmentDetailsStyle = styled.div`
	& .locked-indicator {
		padding: 3px;
		color: white;
		text-align: center;
		font-size: 12px;
		font-weight: bold;
		background: red;
	}

	& .iscollateral-indicator {
		position: relative;
		top: -25px;
		padding: 4px;
		margin: auto;
		color: white;
		text-align: center;
		font-size: 13.5px;
		font-weight: bold;
		background: orange;
		width: 75%;
	}

	& .title {
		text-transform: capitalize;
	}

	& .profile-details {
		& > div {
			display: inline-block;
			padding: 5px;
			margin-right: 5px;

			& .label {
				font-size: 12px;
				color: gray;
			}
		}
	}
`;

const SingleInvestmentTopUpPage = () => {
	const dispatch = useAppDispatch();
	const [searchParams, setSearchParams] = useSearchParams();

	const { investmentTopUps, investmentStatements } = useAppSelector(
		(store) => store.investment
	);

	const topUp = investmentTopUps as any;

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		const updateQueryString = (query: any, action = 'update') => {
			remakeQueryString(query, searchParams, setSearchParams, action);
		};
		const searchParamsObject = Object.fromEntries(searchParams);
		updateQueryString({ topUpId: searchParamsObject.topUpId });
		if (Object.keys(queryData).length > 0) {
			dispatch(investmentTopUpList({ ...queryData }));
		}
		dispatch(
			investmentTransactionStatements({
				associatedInvestmentTopUpId: searchParamsObject.topUpId,
			})
		);
	}, []);
	return (
		<SingleInvestmentDetailsStyle>
			<Card style={{ position: 'relative' }}>
				<Button
					onClick={() => window.history.back()}
					style={{ padding: '10px' }}
				>
					Back
				</Button>
				{/* <Link to={`/user-profile/${savingsProfile?.userId?._id}`}>
					@{savingsProfile?.userId?.username}
				</Link> */}
				<h1 className="title">
					{investmentTopUps ? topUp?.investmentId?.title : 'No Title'}
				</h1>
				<p className="label">Investment Title</p>

				<div className="profile-details">
					<div>
						<p>
							{investmentTopUps ? topUp?.investmentForm : 'No InvestmentForm'}
						</p>
						<p className="label">investmentForm</p>
					</div>

					<div>
						<p>
							{investmentTopUps
								? topUp?.investmentId?.riseInvestmentId
								: 'No riseInvestmentId'}{' '}
						</p>
						<p className="label">Rise vest Investment ID</p>
					</div>
					<div>
						<p>{investmentTopUps ? topUp?.amount : 'No investmentStatus'}</p>
						<p className="label">Amount </p>
					</div>
					<div>
						<p>{investmentTopUps ? topUp?.status : 'No Status'}</p>
						<p className="label">Status</p>
					</div>

					<div>
						<p>
							{investmentTopUps
								? topUp?.transactionStatus
								: 'Transaction Status'}
						</p>
						<p className="label">Transaction Status</p>
					</div>
					<div>
						<p>
							{investmentTopUps
								? topUp?.calculatedFee?.discount
								: 'No Discount'}
						</p>
						<p className="label">No Discount</p>
					</div>

					<div>
						<p>{investmentTopUps ? topUp?.calculatedFee?.fee : 'No Fee'}</p>
						<p className="label">Fee</p>
					</div>
					<div>
						<p>
							{investmentTopUps
								? topUp?.calculatedFee?.feeInUsd
								: 'No currentBalance'}
						</p>
						<p className="label">Fee In USD</p>
					</div>
					<div>
						<p>
							{investmentTopUps
								? topUp?.calculatedFee?.finalAmount
								: 'No final Amount'}
						</p>
						<p className="label">Final Amount</p>
					</div>

					<div>
						<p>
							{investmentTopUps
								? moment(
										investmentTopUps ? topUp?.createdAt : 'No createdAt'
								  ).format('MMM DD, YY / hh:mm:ss a')
								: '--'}
						</p>
						<p className="label">Created Date</p>
					</div>
					<div>
						<p>
							{moment(
								investmentTopUps ? topUp?.updatedAt : 'No updatedAt'
							).format('MMM DD, YY / hh:mm:ss a')}
						</p>
						<p className="label">Updated Date</p>
					</div>
				</div>

				<Divider />
				<h2>Investment TopUp Associated Transaction Statements</h2>
				{investmentStatements.itemsList.map((transaction: any) => (
					<InvestmentTransactionStatements
						key={transaction._id}
						transaction={transaction}
					/>
				))}
			</Card>
		</SingleInvestmentDetailsStyle>
	);
};

export default SingleInvestmentTopUpPage;
